<div class="map-bar">
  <div class="map-bar-content">
    <div class="map-bar-item">
      <div class="d-flex">
        <mat-form-field class="search-input" appearance="outline">
          <input
            matInput
            placeholder="Klantnaam"
            [(ngModel)]="companyName"
            (ngModelChange)="companyNameChanged.next()"
          />
        </mat-form-field>
      </div>
    </div>
    <div class="map-bar-item left-space">
      <mat-form-field class="search-input" appearance="outline">
        <mat-select
          matInput
          multiple
          placeholder="Type plaatsing"
          [(ngModel)]="selectedPlacementTypes"
          (ngModelChange)="selectedPlacementTypesChanged()"
          name="placementTypeSelector"
          [compareWith]="compareOrdinalEnum"
        >
          <mat-option
            *ngFor="let option of PLACEMENT_TYPE_CHOICE_ARRAY"
            [value]="option"
          >
            {{ option.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="filter-types-container">
      <div class="map-bar-item left-space smaller-upper-space">
        <mat-checkbox
          [(ngModel)]="allSelected"
          (ngModelChange)="allSelectedChanged()"
          ><span class="strong">Alle opdrachten</span></mat-checkbox
        >
      </div>
      <div class="map-bar-item left-space smaller-upper-space">
        <mat-checkbox
          [(ngModel)]="withDateSelected"
          (ngModelChange)="filterTypeSelectedChanged()"
          ><span class="strong">Op datum</span></mat-checkbox
        >
      </div>
      <div class="map-bar-item left-space smaller-upper-space">
        <mat-checkbox
          [(ngModel)]="baseProjectSelected"
          (ngModelChange)="filterTypeSelectedChanged()"
          ><span class="strong">Te plaatsen</span></mat-checkbox
        >
      </div>
      <div class="map-bar-item left-space smaller-upper-space">
        <mat-checkbox
          [(ngModel)]="adjustmentSelected"
          (ngModelChange)="filterTypeSelectedChanged()"
          ><span class="strong">Aanpassing</span></mat-checkbox
        >
      </div>
      <div class="map-bar-item left-space smaller-upper-space">
        <mat-checkbox
          [(ngModel)]="soldRentedSelected"
          (ngModelChange)="filterTypeSelectedChanged()"
          ><span class="strong">Verkocht/Verhuurd</span></mat-checkbox
        >
      </div>
      <div class="map-bar-item left-space smaller-upper-space">
        <mat-checkbox
          [(ngModel)]="repoSelected"
          (ngModelChange)="filterTypeSelectedChanged()"
          ><span class="strong">Weghalen</span></mat-checkbox
        >
      </div>
      <div class="map-bar-item left-space smaller-upper-space">
        <mat-checkbox
          [(ngModel)]="taskSelected"
          (ngModelChange)="filterTypeSelectedChanged()"
          ><span class="strong">Taken</span></mat-checkbox
        >
      </div>
      <div class="map-bar-item left-space smaller-upper-space">
        <mat-checkbox
          [(ngModel)]="notExecutedSelected"
          (ngModelChange)="filterTypeSelectedChanged()"
          ><span class="strong">Opnieuw inplannen</span></mat-checkbox
        >
      </div>
      <div class="map-bar-item left-space smaller-upper-space">
        <mat-checkbox
          [(ngModel)]="notInTourSelected"
          (ngModelChange)="filterTypeSelectedChanged()"
          ><span class="strong">Afsp - Niet in toer</span></mat-checkbox
        >
      </div>
      <div class="map-bar-item left-space smaller-upper-space">
        <mat-checkbox
          [(ngModel)]="alreadyInTourSelected"
          (ngModelChange)="filterTypeSelectedChanged()"
          ><span class="strong">Reeds in toer</span></mat-checkbox
        >
      </div>
    </div>
    <div class="map-bar-item flexer ml-3">
      <div class="marker-icons">
        <img
          *ngIf="
            allSelected ||
            baseProjectSelected ||
            (withDateSelected &&
              !baseProjectSelected &&
              !adjustmentSelected &&
              !soldRentedSelected &&
              !repoSelected &&
              !taskSelected)
          "
          src="../../../../../../assets/markers/Groen.png"
          width="28"
          height="38"
        />
        <img
          *ngIf="
            allSelected ||
            adjustmentSelected ||
            (withDateSelected &&
              !baseProjectSelected &&
              !adjustmentSelected &&
              !soldRentedSelected &&
              !repoSelected &&
              !taskSelected)
          "
          src="../../../../../../assets/markers/Blauw.png"
          width="28"
          height="38"
        />
        <img
          *ngIf="
            allSelected ||
            soldRentedSelected ||
            (withDateSelected &&
              !baseProjectSelected &&
              !adjustmentSelected &&
              !soldRentedSelected &&
              !repoSelected &&
              !taskSelected)
          "
          src="../../../../../../assets/markers/Geel.png"
          width="28"
          height="38"
        />
        <img
          *ngIf="
            allSelected ||
            repoSelected ||
            (withDateSelected &&
              !baseProjectSelected &&
              !adjustmentSelected &&
              !soldRentedSelected &&
              !repoSelected &&
              !taskSelected)
          "
          src="../../../../../../assets/markers/Rood.png"
          width="28"
          height="38"
        />
        <img
          *ngIf="
            allSelected ||
            taskSelected ||
            (withDateSelected &&
              !baseProjectSelected &&
              !adjustmentSelected &&
              !soldRentedSelected &&
              !repoSelected &&
              !taskSelected)
          "
          src="../../../../../../assets/markers/Paars.png"
          width="28"
          height="38"
        />
      </div>
    </div>
  </div>
</div>
<div class="map-container" #mapContainer>
  <div *ngIf="!init" class="table-loader-overlay overlay-top">
    <mat-spinner color="primary" diameter="75"></mat-spinner>
  </div>
  <div #mapContainerScrollAnchor class="map-container-scroll-anchor"></div>
  <div class="map-action-button-container">
    <button
      class="map-action-button"
      (click)="centerItems()"
      type="button"
      [matTooltip]="'Centreer nog in te plannen opdrachten'"
    >
      <mat-icon>open_with</mat-icon>
    </button>
    <button
      class="map-action-button"
      (click)="openTourPreviewModal()"
      type="button"
      [matTooltip]="'Previews selecteren'"
    >
      <mat-icon>place</mat-icon>
    </button>
    <!--     <button
      class="map-action-button"
      (click)="openMultiselectModal()"
      type="button"
      [matTooltip]="'Multiselect'"
    >
      <mat-icon>place</mat-icon>
    </button> -->
    <button
      class="map-action-button"
      (click)="resetPreviews()"
      type="button"
      [matTooltip]="'Previews wissen'"
    >
      <mat-icon>close</mat-icon>
    </button>
    <!-- <button
      class="map-action-button"
      (click)="drawRegion()"
      type="button"
      [matTooltip]="'Regio tekenen'"
    >
      <mat-icon>edit</mat-icon>
    </button> -->
  </div>
  <div class="branch-filter-button-container">
    <button
      class="branch-filter-button"
      [class.active]="branchPreviewStates.get('Aalst')"
      (click)="filterByBranch('Aalst')"
      type="button"
      [matTooltip]="'Toon/verberg routes voor filiaal Aalst'"
    >
      Aa
    </button>
    <button
      class="branch-filter-button"
      [class.active]="branchPreviewStates.get('Wilrijk')"
      (click)="filterByBranch('Wilrijk')"
      type="button"
      [matTooltip]="'Toon/verberg routes voor filiaal Wilrijk'"
    >
      Wi
    </button>
    <button
      class="branch-filter-button"
      [class.active]="branchPreviewStates.get('Zelem')"
      (click)="filterByBranch('Zelem')"
      type="button"
      [matTooltip]="'Toon/verberg routes voor filiaal Zelem'"
    >
      Ze
    </button>
    <button
      class="branch-filter-button"
      [class.active]="branchPreviewStates.get('Zoersel')"
      (click)="filterByBranch('Zoersel')"
      type="button"
      [matTooltip]="'Toon/verberg routes voor filiaal Zoersel'"
    >
      Zo
    </button>
  </div>
  <div
    *ngIf="previewSlots != null && previewSlots.length > 0"
    class="slot-legend"
  >
    <div *ngFor="let slot of previewSlots" class="d-flex">
      <span
        class="line"
        [style.background]="
          slot.directionsRenderer?.polylineOptions?.strokeColor
        "
      ></span>
      <span>{{ slot.totalDistance }}</span>
    </div>
  </div>

  <map-view
    [latitude]="INPRESS_COORDINATES.lat"
    [longitude]="INPRESS_COORDINATES.lng"
    [zoom]="currentMapZoom"
    [maxZoom]="19"
    [scrollwheel]="false"
    [styles]="HIDE_POI_STYLE"
    (mapClick)="mapClick()"
    (zoomChange)="handleZoomChange($event)"
  >
    <map-marker
      [latitude]="INPRESS_COORDINATES.lat"
      [longitude]="INPRESS_COORDINATES.lng"
      [iconUrl]="'../../../../../../favicon.ico'"
    ></map-marker>
    <ng-container *ngFor="let group of itemGroups">
      <map-marker
        *ngIf="!group.hide"
        [latitude]="group.lat"
        [longitude]="group.lng"
        [iconUrl]="{
          url: '../../../../../../assets/markers/' + group.markerColor
        }"
        [optimized]="false"
        [zIndex]="100"
        [openInfoWindow]="true"
        (markerClick)="markerClick(infoWindow, group)"
        (mouseOver)="setGroupHovering(group, true)"
        (mouseOut)="setGroupHovering(group, false)"
      >
        <map-info-window #infoWindow>
          <ng-container *ngIf="group.clicked">
            <immo-map-popup
              [itemGroup]="group"
              [placerOptions]="placers"
              [groupSelected]="groupSelected"
              [itemAddedToGroup]="itemAddedToGroup"
              (updatePlanValues)="setSelectedPlanValues($event)"
              (lastItemPlanned)="lastItemForGroupPlanned()"
              (jobClicked)="centerOnMarker(group)"
            ></immo-map-popup>
          </ng-container>
        </map-info-window>
      </map-marker>
      <map-info-window
        *ngIf="group.hovering && group.appointmentInfoDisplay?.length > 0"
        [latitude]="group.lat + appointmentInfoLatitudeOffset"
        [longitude]="group.lng"
        [isOpen]="true"
        [disableAutoPan]="true"
      >
        <span class="preserve-line-break">{{
          group.multipleAppointmentInfoDisplay
            ? 'Meerdere opdrachten op dit adres met afspraak/sleutel afhalen'
            : group.appointmentInfoDisplay
        }}</span>
      </map-info-window>
    </ng-container>
    <ng-container *ngIf="previewSlots?.length > 0">
      <ng-container *ngFor="let previewSlot of previewSlots">
        <ng-container *ngIf="previewSlot.markers?.length > 0">
          <div *ngFor="let marker of previewSlot.markers">
            <map-marker
              [latitude]="marker.lat"
              [longitude]="marker.lng"
              [label]="{
                text: marker.label,
                color: 'white',
                fontWeight: 'bold'
              }"
              [optimized]="false"
              [zIndex]="1"
              [iconUrl]="{
                url: previewSlot.markerPath + marker.pathSuffix,
                labelOrigin: marker.labelOrigin
              }"
              [openInfoWindow]="
                marker.subProjectId != null || marker.immoTaskId != null
              "
              (markerClick)="
                previewMarkerClick(previewSlot, previewInfoWindow, marker)
              "
              (mouseOver)="marker.hovering = true"
              (mouseOut)="marker.hovering = false"
            >
              <map-info-window #previewInfoWindow>
                <ng-container *ngIf="marker.clicked">
                  <preview-marker-popup
                    [subProjectId]="marker.subProjectId"
                    [immoTaskId]="marker.immoTaskId"
                    [placerOptions]="placers"
                    [previewMarkerSelected]="previewMarkerSelected"
                    (updatePlanValues)="setSelectedPlanValues($event)"
                    (itemReplanned)="itemReplanned($event)"
                  ></preview-marker-popup>
                </ng-container>
              </map-info-window>
            </map-marker>
            <map-info-window
              *ngIf="
                marker.hovering &&
                (marker.subProjectId != null || marker.immoTaskId != null) &&
                previewSlot.state != null
              "
              [latitude]="marker.lat + appointmentInfoLatitudeOffset"
              [longitude]="marker.lng"
              [isOpen]="true"
              [disableAutoPan]="true"
            >
              <div
                class="preview-tour-info"
                *ngIf="previewSlot.state.placerFirstName?.length > 0"
              >
                {{ previewSlot.state.placerFirstName }}
              </div>
              <div
                class="small-upper-space preview-tour-info"
                *ngIf="previewSlot.state.date != null"
              >
                {{ previewSlot.state.date | formatDate : '' : 'dd/MM' }}
              </div>
            </map-info-window>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </map-view>
</div>
